"use strict";

module.exports = {
    Single: require("./combo_box/single/SingleComboBoxControlComponent"),
    Multiple: require("./combo_box/multiple/MultipleComboBoxControlComponent"),
    Renderer: require("./combo_box/ComboBoxControlRenderer"),
    Icon: {
        Single: require("./combo_box/icon_single/IconSingleComboBoxControlComponent"),
        Multiple: require("./combo_box/icon_multiple/IconMultipleComboBoxControlComponent"),
        Renderer: require("./combo_box/IconComboBoxControlRenderer"),
    },
};
